import { RegionShared } from "@1games-ru/region-shared";
import { useEffect } from "react";
import rpc from "@1games-ru/rage-rpc";
import useAppDispatch from "@/core/helpers/useAppDispatch";
import { showShop } from "@/domains/shop/slice";

export default function useShowShop(onExit: () => void) {
  const dispatch = useAppDispatch();

  useEffect(() => {
    rpc.register(RegionShared.Cef.Events.Shop.ShopShow, (state) => {
      dispatch(showShop(state.shopId));
    });

    return () => {
      rpc.unregister(RegionShared.Cef.Events.Shop.ShopShow);
    };
  }, [dispatch]);

  useEffect(() => {
    rpc.register(RegionShared.Cef.Events.Shop.ShopHide, () => {
      onExit();
    });

    return () => {
      rpc.unregister(RegionShared.Cef.Events.Shop.ShopHide);
    };
  }, [dispatch, onExit]);
}
